var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("Marca excluída com "),_c('b',[_vm._v("Sucesso")]),_vm._v(".")])}]

export { render, staticRenderFns }